// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.styles_childItem__BvokV {
  height: 3rem;
  width: 100%;
  border: 1px solid #808080b8;
  border-radius: 1rem;
  display: flex;
  justify-content: space-between;
  position: relative;
  margin-top: 0.25rem;
  align-items: center;
  overflow: hidden;
  padding: 0rem 0.5rem; }
  .styles_childItem__BvokV h2 {
    margin: unset;
    display: flex;
    align-items: center;
    max-width: 50%;
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    display: block;
    flex-shrink: 1;
    vertical-align: bottom;
    height: fit-content; }
  .styles_childItem__BvokV p div {
    justify-content: flex-end;
    max-height: 100%;
    align-items: center; }
    .styles_childItem__BvokV p div > div {
      max-height: 100%; }

.styles_feedContainer__XORO6 {
  overflow-x: scroll; }
  .styles_feedContainer__XORO6 > button {
    min-width: 18rem;
    height: 90%; }

.styles_container__d6bGf {
  min-width: 36rem; }
  .styles_container__d6bGf .styles_header__cpA1e {
    width: -webkit-fill-available;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: sticky;
    top: 0rem;
    background: white;
    z-index: 1;
    height: 3rem; }

.styles_features__plTSr {
  margin-top: 0.5rem;
  padding: 0.25rem;
  margin-bottom: 0.5rem; }
  .styles_features__plTSr h2 {
    margin: 0.25rem 0rem; }

.styles_openChildOptions__4QSf1 {
  position: absolute;
  right: 0rem;
  background: white;
  top: 0rem; }
  .styles_openChildOptions__4QSf1 div > button {
    max-width: 1.5rem;
    max-height: 2.7rem !important; }

.styles_progressContainer__zJjLA {
  padding: 0rem 0.25rem;
  margin-top: 0.5rem; }
  .styles_progressContainer__zJjLA span {
    width: 100%; }
`, "",{"version":3,"sources":["webpack://./src/modules/timetracker/components/DedicatedTimeFeed/styles.module.scss","webpack://./src/modules/Core/styles/variables.scss"],"names":[],"mappings":"AAEA;EACE,YAAY;EACZ,WAAW;EACX,2BCYgB;EDXhB,mBAAmB;EACnB,aAAa;EACb,8BAA8B;EAC9B,kBAAkB;EAClB,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAwBhB,oBAAoB,EAAA;EAlCtB;IAaI,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,cAAc;IAEd,mBAAmB;IACnB,gBAAgB;IAChB,uBAAuB;IACvB,cAAc;IACd,cAAc;IACd,sBAAwB;IACxB,mBACF,EAAA;EAzBF;IA2BI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB,EAAA;IA7BvB;MA+BM,gBAAgB,EAAA;;AAMtB;EACE,kBAAkB,EAAA;EADpB;IAGI,gBAAgB;IAChB,WAAW,EAAA;;AAIf;EACE,gBAAgB,EAAA;EADlB;IAGI,6BAA6B;IAC7B,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,gBAAgB;IAChB,SAAS;IACT,iBAAiB;IACjB,UAAU;IACV,YAAY,EAAA;;AAIhB;EACE,kBAAkB;EAClB,gBAAgB;EAChB,qBAAqB,EAAA;EAHvB;IAKI,oBAAoB,EAAA;;AAIxB;EACE,kBAAkB;EAClB,WAAW;EACX,iBAAiB;EACjB,SAAS,EAAA;EAJX;IAMI,iBAAiB;IACjB,6BAA6B,EAAA;;AAIjC;EACE,qBAAqB;EACrB,kBAAkB,EAAA;EAFpB;IAII,WAAW,EAAA","sourcesContent":["@import \"src/modules/Core/styles/variables.scss\";\n\n.childItem {\n  height: 3rem;\n  width: 100%; // Ensure it has a proper width\n  border: 1px solid $grey72;\n  border-radius: 1rem;\n  display: flex;\n  justify-content: space-between;\n  position: relative;\n  margin-top: 0.25rem;\n  align-items: center;\n  overflow: hidden; // Ensures children don't overflow their bounds\n\n  h2 {\n    margin: unset;\n    display: flex;\n    align-items: center;\n    max-width: 50%;\n    // elipsis one line \n    white-space: nowrap;\n    overflow: hidden;\n    text-overflow: ellipsis;\n    display: block;\n    flex-shrink: 1; // Allow it to shrink inside flex container\n    vertical-align: bottom  ;\n    height: fit-content\n  }\n  p div {\n    justify-content: flex-end;\n    max-height: 100%;\n    align-items: center;\n    & > div {\n      max-height: 100%;\n    }\n  }\n  padding: 0rem 0.5rem;\n}\n\n.feedContainer {\n  overflow-x: scroll;\n  & > button {\n    min-width: 18rem;\n    height: 90%;\n  }\n}\n\n.container {\n  min-width: 36rem;\n  & .header {\n    width: -webkit-fill-available;\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    position: sticky;\n    top: 0rem;\n    background: white;\n    z-index: 1;\n    height: 3rem;\n  }\n}\n\n.features {\n  margin-top: 0.5rem;\n  padding: 0.25rem;\n  margin-bottom: 0.5rem;\n  & h2 {\n    margin: 0.25rem 0rem;\n  }\n}\n\n.openChildOptions {\n  position: absolute;\n  right: 0rem;\n  background: white;\n  top: 0rem;\n  & div > button {\n    max-width: 1.5rem;\n    max-height: 2.7rem !important;\n  }\n}\n\n.progressContainer {\n  padding: 0rem 0.25rem;\n  margin-top: 0.5rem;\n  & span {\n    width: 100%;\n  }\n}\n","// @import \"src/modules/Core/styles/variables.scss\";\n\n$white90: #ffffffe6;\n$green50: #00800080;\n\n$white10: #ffffff1a;\n$white18: #ffffff2e;\n$white50: #ffffff80;\n\n$grey3:#80808008;\n$grey5: #8080800d;\n$grey7: #80808012;\n$grey10: #8080801a;\n$grey18: #8080802e;\n$grey36: #8080805c;\n$grey50: #80808080;\n$grey54: #8080808a;\n$grey72: #808080b8;\n$grey90: #808080e6;\n$grey: #808080;\n\n\n$purple100: #800080;\n$purple90: #800080e6;\n$purple72:#800080b8;\n$purple50: #80008080;\n$purple36: #8000805c;\n$purple18: #8000802e;\n\n$dark_purple: #480048;\n$deep_purple: #840000;\n\n$baby_blue: #87ceeb;\n$ui_blue: #1976d2;\n$ui_blue90: #1976d2e6;\n$ui_blue72: #1976d2b8;\n$ui_blue50: #1976d280;\n$pond_green: #72bbbb;\n$pond_green72: #72bbbbb8;\n$ocean_blue: #72abab;\n$ocean_blue90: #72ababe6;\n$ocean_blue72: #72ababb8;\n$ocean_blue50: #72abab80;\n$ocean_blue36: #72abab5c;\n$ocean_blue10: #73abab1a;\n$kermit_green: #72ab72;\n$kermit_green72: #72ab72b8;\n$somewhat_certain:#183672;\n$just_say_ok: #721446;\n$success_street: #723618;\n\n$golden: #ffd700;\n$_golden: #D4AF37;\n$bronze: #cd7f32;\n\n$bronze80: #cd7f32c2;\n$bronze50: #cd7f3280;\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"childItem": `styles_childItem__BvokV`,
	"feedContainer": `styles_feedContainer__XORO6`,
	"container": `styles_container__d6bGf`,
	"header": `styles_header__cpA1e`,
	"features": `styles_features__plTSr`,
	"openChildOptions": `styles_openChildOptions__4QSf1`,
	"progressContainer": `styles_progressContainer__zJjLA`
};
export default ___CSS_LOADER_EXPORT___;
